if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){

    /*
        HOME ARROW
        $('.arrow-home').click(function(event) {
            $('body, html').animate({
                scrollTop: $(window).height()-$('header').outerHeight()*2},
                800, 'easeOutExpo');
        });
    */

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));


    $('.sym-slides').slick({
        accessibility: true
    });

    if(window.location.hash) {
        $('html,body').scrollTop(0);
        var hash = window.location.hash;
        var hashTop = $(hash).offset().top;
        $('html,body').animate({scrollTop:hashTop-150},1000);
         console.log(hashTop);
    }

    $('.top-content__explore-content').click(function(event){
        event.preventDefault();
        let thishref = $(this).attr('href');
        var hashTop = $(thishref).offset().top;
        $('html,body').animate({scrollTop:hashTop-120},1500);
    });

    $('.upcoming-events__slides').slick({
        infinite: true,
        arrows: false,
        dots: true,
        autoplay: true,
        autoplaySpeed: 7000,
        speed: 700,
        fade: false,
        responsive: [
            {
              breakpoint: 500,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: false,
                variableWidth: true,
                centerMode: true,
                autoplay: false
              }
            }
        ]
    });

    const audiovideo = document.querySelector(".videoaudio");

    if (audiovideo != null) {
        audiovideo.addEventListener("click", ()=>{
            const video = document.querySelector(".slide video");
            if (video.muted) {
                video.muted = false;
                audiovideo.classList.add("unmuted")
            } else {
                video.muted = true;
                audiovideo.classList.remove("unmuted")
            }
        })
    }

})();